var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('Tabs',{attrs:{"type":"card"}},[_c('TabPane',{attrs:{"closable":false,"label":"人员信息"}},[_c('person')],1),_c('TabPane',{attrs:{"closable":false,"label":"设备信息"}},[_c('device')],1)],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1583d8e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/report/roomInfo/index.vue
// module id = null
// module chunks = 